var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11689 0.628418H9.11386L0.52002 16.9973L0.521458 16.9999H17.7093L17.7107 16.9973L9.11689 0.628418ZM8.26351 4.99987H9.96724V11.7499H8.26351V4.99987ZM9.11538 15.4999C8.89073 15.4999 8.67113 15.4339 8.48435 15.3103C8.29757 15.1867 8.15199 15.011 8.06602 14.8054C7.98005 14.5998 7.95756 14.3736 8.00138 14.1554C8.04521 13.9372 8.15339 13.7367 8.31223 13.5794C8.47108 13.422 8.67346 13.3149 8.89379 13.2715C9.11412 13.2281 9.34249 13.2504 9.55004 13.3355C9.75758 13.4207 9.93497 13.5648 10.0598 13.7499C10.1846 13.9349 10.2512 14.1524 10.2512 14.3749C10.2512 14.6732 10.1315 14.9594 9.91852 15.1704C9.70552 15.3813 9.41662 15.4999 9.11538 15.4999Z",
    fill: "#FDCE57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.2c99b45cada9c133f4d3b79d0349320f.svg";
export { ForwardRef as ReactComponent };